module.exports = __webpack_public_path__ + "static/img/application1-1.3a85c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application1-1.jpg
// module id = ++/b
// module chunks = 0